import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-reward-whitlist-users',
  templateUrl: './reward-whitlist-users.component.html',
  styleUrls: ['./reward-whitlist-users.component.scss']
})
export class RewardWhitlistUsersComponent implements OnInit {

  fileName: any = ''
  excel_file: any = ''
  page = 1
  WhitelistListUser:any = []
  @Input() rewardCreated_id:any = ''
  WhitlistResponse: any;
  uploadHidden:boolean = false
  getPaginationCount: any;
  Search: string;
  constructor(
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private exportExcelService : ExportExcelService,
    private activateRoute : ActivatedRoute,
    private toast : ToastClientService,
    private xls: XlsxService,


  ) { }

  ngOnInit() {
    console.log("Got reward Id from created Component",this.rewardCreated_id)

    this.activateRoute.params.subscribe((res:any)=>{
      console.log(res.rewardID)
      if(res.rewardID != 0){
        this.rewardCreated_id = res.rewardID
        this.getRewardDetailsOnID(res.rewardID)
      }
    })


  }

  ngOnChanges(){
    console.log("Got reward Id from created Component shown on ng on changes",this.rewardCreated_id)
  }

  downloadExcel(){
    let header = ["CSM Number","Start Date","Offer Code","Pin","Validity"]
    this.exportExcelService.commonPrintHeaders1(header, "Reward_Whitelist_Users",'Users')
  }

  
  importExcel(event) {
      this.fileName = event.target.files[0].name;
      this.excel_file = event.target.files[0]
  }

  upload() {
    const formData = new FormData()
    // formData.append("id",)
    formData.append("excel_data",this.excel_file)
    formData.append("id", this.rewardCreated_id)
    this.apiService.upload1(this.apiConfig.whitelistReward, formData).subscribe((res: any) => {
      try{
        if(res.status == 200){
        console.log(res)
        this.uploadHidden = true
        this.toast.Success("File Uploaded Succcessfully")
        this.WhitlistResponse = res.body.data
        this.excel_file = ''
        this.fileName = ""
        this.getRewardDetailsOnID(this.rewardCreated_id)
      }
      }
      catch{
        
      }
    },err=>{
      this.toast.Error("File Not Uploaded")
    })
  }

  DownloadRejectedRecords(){
    this.xls.export(this.WhitlistResponse.reject, "rejected_list")
  }

  getRewardDetailsOnID(id){
    this.apiService.getHeaders(this.apiConfig.getRewardlist + `?id=${id}&page=${this.page}&search=${this.Search}`).subscribe((res:any)=>{
      console.log(res.body.data.list)
      this.WhitelistListUser = res.body.data.list
      this.getPaginationCount = res.headers.get("X-Pagination-Total-Count")
    })
  }

  toggleStatus(data){
    console.log(data)
    let payload = {
      // Here rewardCreated_id is id of reward from list reward
      "id" : this.rewardCreated_id,
      "flag" : 2,
      'user_id' : data.user_id
    }
    this.apiService.post(this.apiConfig.disableReward,payload)
    .subscribe((res:any)=>{
      console.log(res)
      this.toast.Success(res.body.data.message)
      this.getRewardDetailsOnID(this.rewardCreated_id)
    })

  }

  filter(){
    this.getRewardDetailsOnID(this.rewardCreated_id)
  }

  reset(){
    this.Search = ''
    this.getRewardDetailsOnID(this.rewardCreated_id)
  }

  paginationClick(page){
    this.page = page;
    this.getRewardDetailsOnID(this.rewardCreated_id)

  }

}
